import TableLayout from "@components/TableLayout"
import {data} from './data.js'
 import {motion} from 'framer-motion'

export const NativeVSCrossPlatform = ()=>{
    return(
        <section className="container space-y-14">
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12  space-y-5">

    <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
      >
        {data.heading}{" "}
      </motion.h2> 
          <p className="text-base leading-[1.625rem]  text-center text-dark ">
        {data.paragraph}</p> 
        </div>
        <TableLayout data={data} />
        </section>
    )
} 

